<script>
  import { categoriesById } from '../lib/categories';

  const categoriesLegend = [
    'dairy & eggs',
    'meat',
    'vegetable oils',
    'starches & bread',
    'vegetables & mushrooms',
    'fruits & berries',
  ];

  export let exclude = [];

  export let hovered = null;



</script>


  <div class="legend">
    {#each categoriesLegend as c, i (i)}
      {#if exclude.indexOf(c) === -1}
        <div class="legend-item" on:mouseover={() => { hovered = c; }} on:mouseout={() => { hovered = null; }}>
          <div class="legend-symbol" style:background-color={categoriesById[c].color}></div>
          <div class="legend-label">{categoriesById[c].label}</div>
        </div>
      {/if}
    {/each}
  </div>



<style>



  .legend {
    font-size: 14px;
    line-height: 17px;
    text-align: center;
  }

  .legend-item {
    display: inline-flex;
    align-items: center;
    margin: 2px 4px;
    cursor: default;
    user-select: none;
  }

  .legend-symbol {
    width: 14px;
    height: 14px;
    border-radius: 1px;
    margin-right: 4px;
    flex: 0 0 auto;
  }

  .legend-label {
    flex: 0 0 auto;
  }

</style>
